export const menuList = [
  {
    displayName: "资产视图",
    frontendCode: "view",
    id: 10023,
    path: '/overview',
    icon: 'icon_gailan'
  },
  {
    displayName: "服务提供者管理",
    displayType: "MENU",
    frontendCode: "provider",
    id: 10024,
    path: '/servepro/serveproerlist',
    icon: 'icon_fuwutigongzheguanli',
  },
  {
    displayName: "服务使用者管理",
    displayType: "MENU",
    frontendCode: "consumer",
    id: 10030,
    path: '/serveUse/serveUselist',
    icon: 'icon_fuwushiyongzheguanli'
  },
  {
    displayName: "服务管理",
    displayType: "MENU",
    frontendCode: "service",
    id: 10036,
    path: '/serve/servelist',
    icon: 'icon_fuwuguanli'
  },
  {
    displayName: "应用管理",
    displayType: "MENU",
    frontendCode: "application",
    id: 10042,
    path: '/manage/applist',
    icon: 'icon_yingyongguanli'
  },
  // {
  //   displayName: "视频资源管理",
  //   displayType: "MENU",
  //   frontendCode: "resource",
  //   id: 10049,
  //   path: "/video/videolist",
  //   icon:'icon_shipinziyuanguanli'
  // },
  {
    displayName: "配额审批",
    displayType: "MENU",
    frontendCode: "quota",
    id: 10046,
    path: '/appove/appovelist',
    icon: 'icon_shenpi'
  },
  {
    displayName: "系统设置",
    displayType: "MENU",
    frontendCode: "system",
    id: 10000,
    path: '/setting/userindex/userlist',
    icon:'icon_mianxingshezhi'
  },
  {
    displayName: "消息配置",
    displayType: "MENU",
    frontendCode: "message",
    id: 10055,
    path: '/message/emailset',
    icon:'icon_xiaoxipeizhi'
  },
  {
    displayName: "日志管理",
    displayType: "MENU",
    frontendCode: "log_manage",
    id: 10071,
    path: "/log/index",
    icon: 'icon_fuwushiyongcishu'
  }
]

export const childList = [
  // 服务提供者管理
  {
    displayName: "服务提供者",
    displayType: "MENU",
    frontendCode: "provider_manage",
    id: 10025,
    parentId: 10024,
    path: '/servepro/serveproerlist'
  },
  {
    displayName: "服务提供者审核",
    displayType: "MENU",
    frontendCode: "provider_audit",
    id: 10027,
    parentId: 10024,
    path: '/servepro/serveproerchecklist'
  },
  //服务使用者管理
  {
    displayName: "服务使用者管理",
    displayType: "MENU",
    frontendCode: "consumer_manage",
    id: 10031,
    parentId: 10030,
    path: '/serveUse/serveUselist'
  },
  {
    displayName: "服务使用者审核",
    displayType: "MENU",
    frontendCode: "consumer_audit",
    id: 10033,
    parentId: 10030,
    path: '/serveUse/serveUseChecklist'
  },
  //服务管理
  {
    displayName: "服务管理",
    displayType: "MENU",
    frontendCode: "service_manage",
    id: 10037,
    parentId: 10036,
    path: '/serve/servelist'
  },
  {
    displayName: "服务上下架审核",
    displayType: "MENU",
    frontendCode: "service_audit",
    id: 10039,
    parentId: 10036,
    path: '/serve/servechecklist'
  },
  //应用管理  
  //------------------------------------
  {
    displayName: "服务应用",
    displayType: "MENU",
    frontendCode: "application_manage",
    id: 10043,
    parentId: 10042,
    path: '/manage/applist'
  },
  {
    displayName: "边缘计算应用",
    displayType: "MENU",
    frontendCode: "out_application_manage",
    id: 10067,
    parentId: 10042,
    path: '/manage/applist'
  },
  //视频资源管理
  // {
  //   displayName: "视频资源管理",
  //   displayType: "MENU",
  //   frontendCode: "resource_manage",
  //   id: 10050,
  //   parentId: 10049,
  //   path: '/video/videolist'
  // },
  // {
  //   displayName: "视频资源审批",
  //   displayType: "MENU",
  //   frontendCode: "resource_audit",
  //   id: 10052,
  //   parentId: 10049,
  //   path: '/video/videoapproval'
  // },
  //配额审批 无二级
  //------------------------------------
  //系统设置
  {
    displayName: "中心用户管理",
    displayType: "MENU",
    frontendCode: "IamUser",
    id: 10006,
    parentId: 10000,
    path:'/setting/userindex/userlist'
  },
  {
    displayName: "权限管理",
    displayType: "MENU",
    frontendCode: "IamRole",
    id: 10011,
    parentId: 10000,
    path:'/setting/roleindex/rolelist'
  },
  {
    displayName: "字典管理",
    displayType: "MENU",
    frontendCode: "Dictionary",
    id: 10001,
    parentId: 10000,
    path:'/setting/dictList'
  },
  //消息配置
  {
    displayName: "消息推送配置",
    displayType: "MENU",
    frontendCode: "message_send",
    id: 10058,
    parentId: 10055,
    path:'/message/msgpushset'
  },
  {
    displayName: "邮件配置",
    displayType: "MENU",
    frontendCode: "message_email",
    id: 10057,
    parentId: 10055,
    path:'/message/emailset'
  },
  {
    displayName: "短信配置",
    displayType: "MENU",
    frontendCode: "message_sms",
    id: 10056,
    parentId: 10055,
    path:'/message/messageset'
  },
]